<template>
  <div>
    <div
      :class="legendHovered && 'cursor-pointer'"
      class="relative"
    >
      <canvas
        :id="idChart"
        :height="c_height"
      />
    </div>
    <div
      v-if="tooSmall"
      class="xl:ml-5 mt-5"
    >
      <p
        class="text-2sm text-gray-600"
        v-for="(label, n) in labels"
        :key="n"
      >
        {{ n + ' ' + label }}
      </p>
    </div>
  </div>
</template>

<script>
import ChartDataLabels from 'chartjs-plugin-datalabels';

export default {
  props: {
    height: {
      type: Number,
      required: false,
      default: 250,
    },
    idChart: {
      type: String,
      required: true,
    },
    values: {
      type: Array,
      required: true,
    },
    colors: {
      type: Object,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    labels: {
      type: Array,
      required: false,
    },
    min: {
      type: Number,
      required: false,
      default: 0,
    },
    max: {
      type: Number,
      required: false,
      default: 5,
    },
    maintainAspectRatio: {
      type: Boolean,
      required: false,
      default: true,
    },
    noLabels: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    c_height() {
      return this.smallScreen ? 180 : this.height;
    },
  },

  data() {
    return {
      smallScreen: false,
      tooSmall: false,
      chart: null,
      mediaQuery: null,
      tooSmallThreshold: 200,
      legendHovered: false,
    };
  },

  mounted() {
    this.mediaQuery = window.matchMedia('(min-width: 1296px)');

    let vm = this;
    function handleResize(e) {
      //vm.smallScreen = !e.matches;
    }
    //Initial check
    handleResize(this.mediaQuery);

    this.mediaQuery.addEventListener('change', handleResize);

    this.generateChart();
  },

  methods: {
    generateChart() {
      let ctx = document.getElementById(this.idChart);

      this.chart = new Chart(ctx, {
        plugins: [
          ChartDataLabels,
          {
            afterRender: (chart) => {
              const { width, height } = chart;
              const smaller = width < height ? width : height;
              this.tooSmall = smaller < this.tooSmallThreshold;
            },
          },
        ],
        type: 'radar',
        data: {
          labels: this.labels,
          datasets: this.values,
        },
        options: {
          responsive: true,
          onResize: (_, { width, height }) => {
            const smaller = width < height ? width : height;
            this.tooSmall = smaller < this.tooSmallThreshold;
          },
          maintainAspectRatio: this.maintainAspectRatio,
          legend: {
            position: 'bottom',
            onHover: () => {
              this.legendHovered = true;
            },
            onLeave: () => {
              this.legendHovered = false;
            },
          },
          title: {
            display: this.title,
            text: this.title ? this.title.toUpperCase() : '',
            fontSize: 18,
            fontFamily: 'Montserrat',
            fontColor: '#3A18D1',
            padding: 35,
          },
          scale: {
            angleLines: {
              display: false,
            },
            ticks: {
              suggestedMin: this.min,
              suggestedMax: this.max,
              stepSize: 1,
            },
            pointLabels: {
              callback: this.getLabel,
              fontSize: this.smallScreen ? 9 : 13,
            },
          },
          tooltips: {
            callbacks: {
              title: (tooltipItem, data) => data.labels[tooltipItem[0].index],
              pointLabels: (tooltipItem, data) =>
                data.labels[tooltipItem[0].index],
            },
          },
        },
      });
    },

    /**
     * @param {string} label
     * @param {number} index
     * @param {string[]} labels
     * @returns {string}
     */
    getLabel(label, index, labels) {
      if (this.noLabels) {
        return ''
      }
      if (this.tooSmall) {
        return index.toString();
      } else {
        return label.match(new RegExp('.{1,' + 50 + '}(\\s|$)', 'g'));
      }
    },
  },
  watch: {
    values() {
      this.generateChart();
    },
    tooSmall() {
      this.chart.update();
    },
  },
};
</script>
